module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "siteSetting-container"
    }
  }, [_c('el-form', {
    ref: "initForm",
    attrs: {
      "label-width": "120px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "当前场地"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.oriSiteName) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更改场地",
      "prop": "teaCodeArray"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "visible-change": _vm.handleVisibleChange,
      "change": _vm.handleSiteChange
    },
    model: {
      value: (_vm.siteCodeArray),
      callback: function($$v) {
        _vm.siteCodeArray = $$v
      },
      expression: "siteCodeArray"
    }
  }, _vm._l((_vm.comboOption.site), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName + '（' + item.capacity + '人）' + item.otherInfo,
        "disabled": item.comboState
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-116cf325"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/timetableManage/arrange/siteSetting.vue
// module id = 1776
// module chunks = 502